import React, {useContext, useEffect, useMemo} from "react";
import {Marker} from "react-map-gl";
import ClusterContext from "./ClusterContext";
import ClusteringTrafficLocationOn from "../common/ClusteringTrafficLocationOn";
import {parseAndValidateLngLat} from "../../utils/geo";

// Registers traffic markers with the ClusterHandler via context. The handler
// performs the clustering and renders either a ClusterMarker or the original
// Marker element depending on zoom/extent.
const TrafficClusterGroup = ({trafficData, setActiveTrafficSelectedOnMap}) => {
    const {registerMarkers, unRegisterMarkers} = useContext(ClusterContext);

    const markers = useMemo(() => {
        if (!Array.isArray(trafficData)) return [];

        return trafficData
            .map((trafficObject, index) => {
                const pointCoords =
                    trafficObject?.groupOfLocations?.tpegPointLocation?.point?.pointCoordinates;

                const {lat, lng, valid} = parseAndValidateLngLat(
                    pointCoords?.longitude, pointCoords?.latitude
                );
                if (!valid) return null;

                return (
                    <Marker
                        key={`traffic-${index}-${lat}-${lng}`}
                        latitude={lat}
                        longitude={lng}
                        offsetLeft={-20}
                        offsetTop={-40}
                    >
                        <ClusteringTrafficLocationOn
                            trafficObject={trafficObject}
                            onClick={() => setActiveTrafficSelectedOnMap(trafficObject, true)}
                        />
                    </Marker>
                );
            })
            .filter(Boolean);
    }, [trafficData, setActiveTrafficSelectedOnMap]);

    useEffect(() => {
        if (!registerMarkers || !unRegisterMarkers) return;
        registerMarkers(markers);
        return () => unRegisterMarkers(markers);
    }, [registerMarkers, unRegisterMarkers, markers]);

    // The actual rendering of clusters/markers is handled by ClusterHandler
    // using the registered markers, so this component itself renders nothing.
    return null;
};

export default TrafficClusterGroup;
